import styled from "styled-components";
export const PublicTicketsMenuStyle = styled.div``;
